// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router';
import './ResourceGeneratorOutput.css';

type Props = {
  cohortStatus: ?Array<any>,
  downloadCohortYaml: Function,
};

export class ResourceGeneratorOutput extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      cohortStatus: this.props.cohortStatus,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!_.isEqual(this.props.cohortStatus, nextProps.cohortStatus)) {
      this.setState({
        cohortStatus: nextProps.cohortStatus,
      });
    }
  }

  generateCohortStatus = () => {
    const { cohortStatus } = this.state;
    if (!cohortStatus) {
      return (
        <div />
      );
    }

    const cohortStatusContainer = [];
    for (let index = 0; index < cohortStatus.length; index += 1) {
      cohortStatusContainer.push(
        <tr key={cohortStatus[index].cohortID[0]}>
          <td>
            <Link to={`/cohorts/${cohortStatus[index].cohortID[0]}`}>
              {cohortStatus[index].cohortID[0]}
            </Link>
          </td>
          <td>{this.renderStatus(cohortStatus[index].status)}</td>
          {cohortStatus[index].status === 2 ?
            <td
              className="download-button"
              onClick={() => this.props.downloadCohortYaml(cohortStatus[index].cohortID[0])}
            >
              Download
            </td> : <td />
          }

        </tr>
      );
    }

    return (
      <table className="center-table table is-striped is-fullwidth">
        <thead>
          <tr>
            <td>COHORT ID</td>
            <td>STATUS</td>
            <td />
          </tr>
        </thead>
        <tbody>
          {cohortStatusContainer}
        </tbody>
      </table>
    );
  }

  renderStatus = (status: number) => {
    switch (status) {
      case 1:
        return 'Pending';
      case 2:
        return 'Completed';
      default:
        return 'Failed';
    }
  }

  render() {
    return (
      <div>
        {this.generateCohortStatus()}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/resource_generator/ResourceGeneratorOutput.jsx
 **/